export default __webpack_public_path__ + "static/media/icon-declined-fill.f1c61f24.svg";